var cms = function () {

  var publicMethods = {};

  var elements = document.querySelectorAll('.cms');

  publicMethods.init = function () {

    if (!elements.length) return;

    for (var i = 0; i < elements.length; i++) {

      (function (i) {

        var tables = elements[i].querySelectorAll('table');

        if (tables.length) {

          var tableWrapper = document.createElement('div');
          tableWrapper.classList.add('cms-table');
          wrapAll(tables, tableWrapper);


        }

        var iframes = elements[i].querySelectorAll('iframe[src*="youtube.com"]');

        if (iframes.length) {

          var iframeWrapper = document.createElement('div');
          iframeWrapper.classList.add('cms-video');
          wrapAll(iframes, iframeWrapper);


        }

      })(i);

    }

  };

  // https://stackoverflow.com/questions/3337587/wrapping-a-set-of-dom-elements-using-javascript

  function wrapAll(nodes, wrapper) {

    // Cache the current parent and previous sibling of the first node.
    var parent = nodes[0].parentNode;
    var previousSibling = nodes[0].previousSibling;

    // Place each node in wrapper.
    //  - If nodes is an array, we must increment the index we grab from 
    //    after each loop.
    //  - If nodes is a NodeList, each node is automatically removed from 
    //    the NodeList when it is removed from its parent with appendChild.
    for (var i = 0; nodes.length - i; wrapper.firstChild === nodes[0] && i++) {
      wrapper.appendChild(nodes[i]);
    }

    // Place the wrapper just after the cached previousSibling,
    // or if that is null, just before the first child.
    var nextSibling = previousSibling ? previousSibling.nextSibling : parent.firstChild;
    parent.insertBefore(wrapper, nextSibling);

    return wrapper;

  };

  return publicMethods;

}();

cms.init();
